import * as React from "react";
import GcsCredentialsFieldGroup, {
  validateGcsCredentialsFields
} from "data-tiering/repository-management/GcsCredentialsFieldGroup";
import GcsRepositorySetupInfo from "data-tiering/repository-management/GcsRepositorySetupInfo";
import { GCS_AUTH_MODE } from "data-tiering/repository-management/types";
import GcsCredentialsFormFields, {
  validateGcsCredentialsForm
} from "data-tiering/warm-tier-repositories/GcsCredentialsFormFields";
const GcsEditFields = ({ record }) => {
  var _a;
  const gcsRecord = record;
  return /* @__PURE__ */ React.createElement(
    GcsCredentialsFormFields,
    {
      keyIsSet: !!((_a = gcsRecord == null ? void 0 : gcsRecord.service_account_key) == null ? void 0 : _a.is_set),
      clientEmail: gcsRecord == null ? void 0 : gcsRecord.client_email
    }
  );
};
const initialEditValues = (stored) => {
  var _a;
  const record = stored;
  return record ? {
    auth_mode: record.auth_mode,
    service_account_key: ((_a = record.service_account_key) == null ? void 0 : _a.is_set) ? { keep_value: true } : void 0
  } : { auth_mode: "automatic" };
};
const toUpdatePayload = (values) => ({
  type: "gcs",
  auth_mode: values.auth_mode,
  service_account_key: values.auth_mode === "service_account_key" ? values.service_account_key : void 0
});
const gcsDefinition = {
  create: {
    initialValues: () => ({
      type: "gcs",
      auth_mode: GCS_AUTH_MODE.AUTOMATIC,
      service_account_key: void 0
    }),
    validate: (credentials) => validateGcsCredentialsFields(credentials),
    Fields: GcsCredentialsFieldGroup,
    SetupInfo: GcsRepositorySetupInfo
  },
  edit: {
    initialValues: initialEditValues,
    validate: (values) => validateGcsCredentialsForm(values),
    toPayload: (values) => toUpdatePayload(values),
    Fields: GcsEditFields
  }
};
export default gcsDefinition;
